import { useApprovals } from "../../lib/queries";
import { useCockpit } from "../../lib/state";
import { relativeTime } from "../../lib/format";
import { projectGradientCss } from "../../lib/projectColor";

const CLASS_COLOR: Record<string, string> = {
  blocking: "#cf6679",
  notify: "#d4a04c",
  silent: "var(--plum)",
};

export default function ApprovalsQueue() {
  const { data: approvals = [] } = useApprovals();
  const openDrawer = useCockpit((s) => s.openDrawer);
  const pending = approvals.filter((a) => a.status === "pending");

  return (
    <div className="flex flex-col">
      <div className="flex items-center justify-between px-2 pt-2 pb-1">
        <span
          className="font-eyebrow"
          style={{
            fontSize: 10,
            fontWeight: 800,
            letterSpacing: "0.2em",
            textTransform: "uppercase",
            color: "var(--hot-pink)",
          }}
        >
          ✦ Approvals
        </span>
        <span
          className="font-eyebrow"
          style={{ fontSize: 10, fontWeight: 700, color: "var(--plum)", opacity: 0.6 }}
        >
          {pending.length}
        </span>
      </div>
      {pending.length === 0 ? (
        <span
          className="px-2 pb-2 text-xs"
          style={{ fontFamily: "Fraunces, serif", fontStyle: "italic", color: "var(--plum)", opacity: 0.7 }}
        >
          none open · clean queue
        </span>
      ) : (
        <div className="flex flex-col gap-1.5 px-1">
          {pending.map((a) => (
            <button
              key={a.id}
              type="button"
              onClick={() => openDrawer("approval", a.id)}
              className="aero-glass aero-glass-tight flex flex-col items-start gap-1 px-3 py-2 text-left transition-transform hover:-translate-y-0.5"
              style={{ borderRadius: 14 }}
            >
              <div className="flex w-full items-center gap-2">
                <span
                  className="glossy-radial-bubble"
                  style={{
                    width: 8,
                    height: 8,
                    color: CLASS_COLOR[a.class] ?? "var(--plum)",
                  }}
                />
                <span
                  className="flex-1 truncate"
                  style={{
                    fontFamily: "Fraunces, serif",
                    fontStyle: "italic",
                    fontWeight: 600,
                    fontSize: 12.5,
                    color: "var(--ink)",
                  }}
                >
                  {a.action}
                </span>
                <span
                  className="font-eyebrow"
                  style={{ fontSize: 9, letterSpacing: "0.1em", color: "var(--plum)", opacity: 0.6 }}
                >
                  {relativeTime(a.requested_at)}
                </span>
              </div>
              <span
                className="glossy-project-pill"
                style={{ background: projectGradientCss(a.project, 135) }}
              >
                {a.project}
              </span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}
